export const coinWiki = {
  name: 'coinCharge',
  path: '/coinwiki',
  component: () => import('@/components/common/CoinWiki.vue'),
  meta: {
    layout: 'empty',
    gnbSub: false
  }
}
